<div class="lvi-content">
    <div class="avatar">
        <i *ngIf="avatar === typesPrestaEnum.VOITURE_PERSONNELLE || avatar === typesPrestaEnum.VOITURE_DE_LOCATION || avatar === typesPrestaEnum.VOITURE_SOCIETE" class="nio icon-voiture align-middle"></i>
        <i *ngIf="avatar === typesPrestaEnum.AVION" class="nio icon-avion align-middle"></i>
        <i *ngIf="avatar === typesPrestaEnum.AVION_TRAIN" class="nio icon-aviontrain align-middle"></i>
        <i *ngIf="avatar === typesPrestaEnum.TRAIN" class="nio icon-train align-middle"></i>
        <i *ngIf="avatar === typesPrestaEnum.HOTEL" class="nio icon-accueil align-middle"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="openClasse(data)">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="prestationLibelle">
                <strong [translate]="'admin.voyages.referentiels.prestation'"></strong>
                <span>{{ prestationLibelle }}</span>
            </li>
            <li *ngIf="data.code">
                <strong [translate]="'admin.voyages.referentiels.code'"></strong>
                <span>{{ data.code }}</span>
            </li>
            <li>
                <strong [translate]="'admin.voyages.referentiels.personnalise'"></strong>
                <span>{{ (data.custom ? 'global.oui' : 'global.non') | translate }}</span>
            </li>
            <li>
                <strong [translate]="'admin.voyages.referentiels.actif'"></strong>
                <span>{{ (data.actif ? 'global.oui' : 'global.non') | translate }}</span>
            </li>
        </ul>
    </div>
</div>
